import gql from "graphql-tag";

export default gql`
  query Assets(
    $offset: Int
    $limit: Int
    $customerId: ID
    $orderByCreationDate: String
    $orderByCodename: String
    $orderByLastUsed: String
    $format: String
    $categoryIds: [String]
  ) {
    assets(
      offset: $offset
      limit: $limit
      customerId: $customerId
      orderByCreationDate: $orderByCreationDate
      orderByCodename: $orderByCodename
      orderByLastUsed: $orderByLastUsed
      format: $format
      categoryIds: $categoryIds
    ) {
      items {
        id
        customerId
        codename
        format
        hasGraphicsets
        categories {
          name
        }
        sizePx {
          x
          y
        }
      }
      total
    }
  }
`;
